import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class IrrigationMethodService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<IrrigationMethod[]> => {
    return this.apiHttp.get<IrrigationMethod[]>("irrigationmethods");
  };

  public get = (id: number): Observable<IrrigationMethod> => {
    return this.apiHttp.get<IrrigationMethod>(`irrigationmethods/${id}`);
  };
}

export interface IrrigationMethod {
  id: number;
  name: string;
  isActive: boolean;
  requiresFollowup: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/irrigation-method.service.ts